import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import "./LanguageSelector.css";

const LanguageSelector = () => {
  const { locale, switchLanguage } = useLanguage();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  const changeLanguage = (newLocale: "en" | "es" | "pt") => {
    switchLanguage(newLocale);
    setDropdownOpen(false);
  };

  const localeToFlag: { [key in "en" | "es" | "pt"]: string } = {
    en: "/US.png",
    es: "/ES.png",
    pt: "/BR.png",
  };

  return (
    <div className="fitprenda-modal-close-lang-container">
      <div className={`new-custom-dropdown ${isDropdownOpen ? "open" : ""}`}>
        <div className="new-selected-language" onClick={toggleDropdown}>
          <img
            src={localeToFlag[locale as "en" | "es" | "pt"]}
            alt={`${locale}-lang`}
            className="language-flag-img"
          />
        </div>
        {isDropdownOpen && (
          <div className="new-dropdown-options">
            <div onClick={() => changeLanguage("es")}>Español</div>
            <div onClick={() => changeLanguage("pt")}>Português</div>
            <div onClick={() => changeLanguage("en")}>English</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
